import React from 'react';
// import * as Scroll from 'react-scroll';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import IDHelpers from '../../../../core/helpers/IDHelper';
import { Block } from '../..';
import constants from '../../../../core/constants';
import ArrowLeft from '../../../../assets/icons/iconArrowLeft2.svg';
import ArrowRight from '../../../../assets/icons/iconArrowRight2.svg';
import dArrowLeft from '../../../../assets/icons/d-iconArrowLeft2.svg';
import dArrowRight from '../../../../assets/icons/d-iconArrowRight2.svg';
import Megaphone from '../../../../assets/icons/megaphone2.svg';
import Label from '../../Label';

const Container = styled.div.attrs((props: any) => ({
  maxOverlaping: props.maxOverlaping
}))`
  background-color: #fafdff;
  margin-top: 0px;
  width: calc(100% - 10px);
  height: ${(props) =>
    isMobile ? props.maxOverlaping * 37 + 5 : props.maxOverlaping * 32 + 8}px;
  display: flex;
  position: relative;
  margin: 0 5px;

  .countItems {
    display: inline-block;
    background-color: var(--text-primary);
    border-radius: 50%;
    min-width: 18px;
    height: 18px;
    align-self: center;
    text-align: center;
    line-height: 18px;
    margin-right: 4px;
  }
  .textEllipsis {
    padding-left: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 95%;
    display: inline-block;
    cursor: pointer;
  }
  .gridCell {
    flex: 1 0 80px;
    min-width: 80px;
    border-color: #fff;
    border-right-width: 1px;
  }
  .gridCell div {
    display: flex;
    cursor: pointer;
  }
  .label {
    cursor: pointer;
    display: flex;
  }
  .last {
    border-right-width: 0px;
  }
  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
    width: calc(100% - 5px);
    margin: 0px;
  }
`;

const RangeContainer = styled.div.attrs((props: any) => ({
  size: props.size,
  prev: props.prev || 0,
  top: props.top || 0
}))`
  position: absolute;
  width: calc(${(props) => (100 / 7) * props.size}%);
  left: ${(props) => (100 / 7) * props.prev}%;
  top: ${(props) => (isMobile ? props.top * 37 + 5 : props.top * 32 + 8)}px;
  margin: 0px;
  display: flex;
  cursor: pointer;
  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
    width: calc(${(props) => (100 / 7) * props.size}% - 10px);
    margin: 0 5px;
  }
`;

const RangeContainerText = styled.div.attrs((props: any) => ({
  left: props.left || false,
  right: props.right || false
}))`
  display: flex;
  text-align: left;
  background-color: var(--decorative-decorative02);
  padding-left: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  // width: calc(
  //   100% - ${(props) => (props.left ? 28 : 0) + (props.right ? 28 : 0)}px
  // );
  width: 100%;
  float: left;
  border-bottom-left-radius: ${(props) => (props.left ? 0 : 4)}px;
  border-top-left-radius: ${(props) => (props.left ? 0 : 4)}px;
  border-bottom-right-radius: ${(props) => (props.right ? 0 : 4)}px;
  border-top-right-radius: ${(props) => (props.right ? 0 : 4)}px;
  justify-content: space-between;
`;

const Range = (props: any) => {
  const { size, prev, text, left, right, top, countItems, onClick } = props;
  return (
    <RangeContainer size={size} prev={prev} top={top} onClick={onClick}>
      {left && (
        <img
          src={isMobile ? ArrowLeft : dArrowLeft}
          alt=""
          style={{ float: 'left' }}
        />
      )}
      <RangeContainerText left={left} right={right}>
        <Block flex style={{ width: '75%' }}>
          {countItems && (
            <Label
              text={`${countItems}+`}
              black
              size={10}
              lineHeight={14}
              color="#fff"
              className="countItems"
            />
          )}
          <Label
            color="#fff"
            text={text}
            black
            size={isMobile ? 14 : 12}
            lineHeight={isMobile ? 32 : 24}
            className="textEllipsis"
          />
        </Block>
        <img
          src={Megaphone}
          alt=""
          style={{ height: 18, alignSelf: 'center', paddingRight: 8 }}
        />
      </RangeContainerText>
      {right && (
        <img
          src={isMobile ? ArrowRight : dArrowRight}
          alt=""
          style={{ float: 'left' }}
        />
      )}
    </RangeContainer>
  );
};

const RangeBar = (props: any) => {
  const { handleSelect, ranges, selectedDate } = props;
  const data = ranges;
  // const LinkS = Scroll.Link;

  const dataFilter = data?.filter((f: any) => !f.isHidden);
  let maxOverlaping = Math.max.apply(
    null,
    dataFilter?.map((d: any) => (d.overlaping || 0) + 1)
  );

  const selectedDay = selectedDate?.getDay() === 0 ? 7 : selectedDate?.getDay();
  const dayArray = isMobile ? [selectedDay] : [1, 2, 3, 4, 5, 6, 7];
  const selectedElement: any = data?.find(
    (f: any) => f.day === selectedDay && f.isHidden
  );
  maxOverlaping = isMobile ? selectedElement?.count : maxOverlaping;

  return (
    <Container
      maxOverlaping={maxOverlaping >= 3 && isMobile ? 1 : maxOverlaping}
    >
      {dayArray.map((fd) => {
        const items = dataFilter?.filter((f: any) => f.start === fd);

        if (selectedElement?.count >= 3 && isMobile) {
          return (
            <div
              role="gridcell"
              className="gridCell last"
              key={IDHelpers.generateID()}
            >
              <div role="presentation">
                {/* <LinkS
                  activeClass="active"
                  to={`acad-${selectedElement.id}`}
                  spy
                  smooth
                  duration={10}
                  containerId="WrapScrollPanel"
                > */}
                <Range
                  key={IDHelpers.generateID()}
                  size={7}
                  prev={0}
                  text={selectedElement?.text}
                  top={0}
                  left={false}
                  right={false}
                  countItems={selectedElement?.count}
                  onClick={() => {
                    handleSelect(selectedElement.id);
                  }}
                />
                {/* </LinkS> */}
              </div>
            </div>
          );
        }
        return (
          <div
            key={IDHelpers.generateID()}
            role="gridcell"
            className={`${
              fd === dayArray[dayArray.length - 1]
                ? 'gridCell last'
                : 'gridCell'
            }`}
          >
            <div role="presentation">
              {items?.map((d: any) => (
                <Range
                  key={IDHelpers.generateID()}
                  size={isMobile ? 7 : d.size}
                  prev={isMobile ? 0 : d.start! - 1}
                  text={d.text}
                  top={d.overlaping}
                  left={d.left}
                  right={d.right}
                  onClick={() => {
                    handleSelect(d.id);
                  }}
                />
              ))}
            </div>
          </div>
        );
      })}
    </Container>
  );
};

export default RangeBar;
